export const LEAD_PERMISSIONS = {
  canAllLeads: 'lead:*',
  canViewLeads: 'lead:view',
  canDetailLeads: 'lead:detail',
  canEditLeads: 'lead:edit',
  canCreateLeads: 'lead:create',
  canDeleteLeads: 'lead:delete',
} as const;

export const CLIENT_PERMISSIONS = {
  canAllClients: 'client:*',
  canViewClients: 'client:view',
  canDetailClients: 'client:detail',
  canEditClients: 'client:edit',
  canCreateClients: 'client:create',
  canDeleteClients: 'client:delete',
} as const;

export const SCHEDULE_PERMISSIONS = {
  canAllSchedules: 'schedule:*',
  canViewSchedules: 'schedule:view',
  canDetailSchedules: 'schedule:detail',
  canEditSchedules: 'schedule:edit',
  canCreateSchedules: 'schedule:create',
  canDeleteSchedules: 'schedule:delete',
} as const;

export const JOB_PERMISSIONS = {
  canAllJobs: 'job:*',
  canViewAllJobs: 'job:viewAll',
  canViewJobs: 'job:view',
  canDetailJobs: 'job:detail',
  canEditJobs: 'job:edit',
  canCreateJobs: 'job:create',
  canDeleteJobs: 'job:delete',
} as const;

export const TASK_PERMISSIONS = {
  canAllTasks: 'task:*',
  canViewAllTasks: 'task:viewAll',
  canViewTasks: 'task:view',
  canDetailTasks: 'task:detail',
  canEditTasks: 'task:edit',
  canCreateTasks: 'task:create',
  canDeleteTasks: 'task:delete',
  canAssignOverbookingTasks: 'task:assignOverbooking',
} as const;

export const QUOTE_PERMISSIONS = {
  canAllQuotes: 'quote:*',
  canViewQuotes: 'quote:view',
  canDetailQuotes: 'quote:detail',
  canEditQuotes: 'quote:edit',
  canCreateQuotes: 'quote:create',
  canDeleteQuotes: 'quote:delete',
} as const;

export const ORDER_PERMISSIONS = {
  canAllOrders: 'order:*',
  canViewOrders: 'order:view',
  canDetailOrders: 'order:detail',
  canEditOrders: 'order:edit',
  canCreateOrders: 'order:create',
  canDeleteOrders: 'order:delete',
} as const;

export const INVOICE_PERMISSIONS = {
  canAllInvoices: 'invoice:*',
  canViewInvoices: 'invoice:view',
  canDetailInvoices: 'invoice:detail',
  canEditInvoices: 'invoice:edit',
  canCreateInvoices: 'invoice:create',
  canDeleteInvoices: 'invoice:delete',
} as const;

export const PRODUCT_PERMISSIONS = {
  canAllProducts: 'product:*',
  canViewProducts: 'product:view',
  canDetailProducts: 'product:detail',
  canEditProducts: 'product:edit',
  canCreateProducts: 'product:create',
  canDeleteProducts: 'product:delete',
} as const;

export const PACKAGE_PERMISSIONS = {
  canAllPackages: 'package:*',
  canViewPackages: 'package:view',
  canDetailPackages: 'package:detail',
  canEditPackages: 'package:edit',
  canCreatePackages: 'package:create',
  canDeletePackages: 'package:delete',
} as const;

export const QUARANTINE_PERMISSIONS = {
  canAllQuarantines: 'quarantine:*',
  canViewQuarantines: 'quarantine:view',
  canDetailQuarantines: 'quarantine:detail',
  canEditQuarantines: 'quarantine:edit',
  canCreateQuarantines: 'quarantine:create',
  canDeleteQuarantines: 'quarantine:delete',
} as const;

export const REPORT_PERMISSIONS = {
  canAllReports: 'report:*',
  canViewReports: 'report:view',
  canDetailReports: 'report:detail',
  canEditReports: 'report:edit',
  canCreateReports: 'report:create',
  canDeleteReports: 'report:delete',
} as const;

export const TRUCK_PERMISSIONS = {
  canAllTrucks: 'truck:*',
  canViewTrucks: 'truck:view',
  canDetailTrucks: 'truck:detail',
  canEditTrucks: 'truck:edit',
  canCreateTrucks: 'truck:create',
  canDeleteTrucks: 'truck:delete',
} as const;

export const TRAILER_PERMISSIONS = {
  canAllTrailers: 'trailer:*',
  canViewTrailers: 'trailer:view',
  canDetailTrailers: 'trailer:detail',
  canEditTrailers: 'trailer:edit',
  canCreateTrailers: 'trailer:create',
  canDeleteTrailers: 'trailer:delete',
} as const;

export const EQUIPMENT_PERMISSIONS = {
  canAllEquipments: 'equipment:*',
  canViewEquipments: 'equipment:view',
  canDetailEquipments: 'equipment:detail',
  canEditEquipments: 'equipment:edit',
  canCreateEquipments: 'equipment:create',
  canDeleteEquipments: 'equipment:delete',
} as const;

export const VENDOR_PERMISSIONS = {
  canAllVendors: 'vendor:*',
  canViewVendors: 'vendor:view',
  canDetailVendors: 'vendor:detail',
  canEditVendors: 'vendor:edit',
  canCreateVendors: 'vendor:create',
  canDeleteVendors: 'vendor:delete',
} as const;

export const PURCHASE_ORDER_PERMISSIONS = {
  canAllPurchaseOrders: 'purchase:*',
  canViewPurchaseOrders: 'purchase:view',
  canDetailPurchaseOrders: 'purchase:detail',
  canEditPurchaseOrders: 'purchase:edit',
  canCreatePurchaseOrders: 'purchase:create',
  canDeletePurchaseOrders: 'purchase:delete',
} as const;

export const USER_PERMISSIONS = {
  canAllUsers: 'user:*',
  canViewUsers: 'user:view',
  canDetailUsers: 'user:detail',
  canEditUsers: 'user:edit',
  canCreateUsers: 'user:create',
  canDeleteUsers: 'user:delete',
} as const;

export const ROLE_PERMISSIONS = {
  canAllRoles: 'role:*',
  canViewRoles: 'role:view',
  canDetailRoles: 'role:detail',
  canEditRoles: 'role:edit',
  canCreateRoles: 'role:create',
  canDeleteRoles: 'role:delete',
} as const;

export const COUPON_PERMISSIONS = {
  canAllCoupons: 'coupon:*',
  canViewCoupons: 'coupon:view',
  canDetailCoupons: 'coupon:detail',
  canEditCoupons: 'coupon:edit',
  canCreateCoupons: 'coupon:create',
  canDeleteCoupons: 'coupon:delete',
} as const;

export const EVENT_TYPE_PERMISSIONS = {
  canAllEventTypes: 'eventType:*',
  canViewEventTypes: 'eventType:view',
  canDetailEventTypes: 'eventType:detail',
  canEditEventTypes: 'eventType:edit',
  canCreateEventTypes: 'eventType:create',
  canDeleteEventTypes: 'eventType:delete',
} as const;

export const CATEGORY_PERMISSIONS = {
  canAllCategory: 'category:*',
  canViewCategory: 'category:view',
  canDetailCategory: 'category:detail',
  canEditCategory: 'category:edit',
  canCreateCategory: 'category:create',
  canDeleteCategory: 'category:delete',
} as const;

export const CHECKLIST_PERMISSIONS = {
  canAllChecklists: 'checklist:*',
  canViewChecklists: 'checklist:view',
  canDetailChecklists: 'checklist:detail',
  canEditChecklists: 'checklist:edit',
  canCreateChecklists: 'checklist:create',
  canDeleteChecklists: 'checklist:delete',
} as const;

export const VENUE_PERMISSIONS = {
  canAllVenue: 'venue:*',
  canViewVenue: 'venue:view',
  canDetailVenue: 'venue:detail',
  canEditVenue: 'venue:edit',
  canCreateVenue: 'venue:create',
  canDeleteVenue: 'venue:delete',
} as const;

export const DASHBOARD_PERMISSIONS = {
  canAllDashboard: 'dashboard:*',
  canCommissionAllDashboard: 'dashboard:commissionAll',
} as const;
